// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * CSS pour l'onglet Présentation
 */

.tab-presentation {
  /* Carte / fond blanc retires : les sections (SectionPliable) portent leur propre cadre. */
}

.tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.tab-header h2 {
  margin: 0;
  font-size: 2rem;
  font-weight: 600;
  color: #1f2937;
}

/* Mode lecture */
.presentation-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.presentation-section {
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #f3f4f6;
}

.presentation-section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.presentation-section h3 {
  font-size: 1.6rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 1rem 0;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1rem;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.info-item label {
  font-size: 1.2rem;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.info-item span {
  font-size: 1.4rem;
  color: #1f2937;
}

.info-item a {
  color: #f97316;
  text-decoration: none;
}

.info-item a:hover {
  text-decoration: underline;
}

.description-text {
  font-size: 1.4rem;
  color: #4b5563;
  line-height: 1.6;
  white-space: pre-line;
}

.history-table {
  overflow-x: auto;
}

.history-table table {
  width: 100%;
  border-collapse: collapse;
}

.history-table th,
.history-table td {
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
}

.history-table th {
  background: #f9fafb;
  font-size: 1.2rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
}

.history-table td {
  font-size: 1.4rem;
  color: #1f2937;
}

/* Mode édition */
.presentation-form {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.form-section {
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #f3f4f6;
}

.form-section h3 {
  font-size: 1.6rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 0.5rem 0;
}

.section-hint {
  font-size: 1.2rem;
  color: #6b7280;
  margin: 0 0 1rem 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  font-size: 1.4rem;
  font-weight: 500;
  color: #374151;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 1.2rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  font-size: 1.6rem;
  color: #2c3948;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: #9ca3af;
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

/* Description de l'entreprise : la hauteur suit le contenu (auto-resize JS),
   donc pas de scroll interne ni de poignee de resize manuel. */
.form-group textarea.auto-grow {
  resize: none;
  overflow: hidden;
}

/* Historique CA/RH */
.history-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.year-row {
  display: grid;
  grid-template-columns: 80px 1fr 1fr;
  gap: 1rem;
  align-items: end;
}

.year-label {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
  padding-bottom: 0.625rem;
}

/* Sections avec bandeau noir */
/* .form-section-block / .section-banner : structure remplacee par SectionPliable.
   Regles supprimees pour ne pas laisser de chrome residuel. */

.section-content {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  overflow: hidden;
  position: relative;
}

.section-description {
  font-size: 1.4rem;
  color: #374151;
  margin: 0 0 1rem 0;
  font-weight: 500;
}

/* Mode lecture */
.view-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.view-group label {
  font-size: 1.4rem;
  font-weight: 500;
  color: #374151;
}

.view-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.view-item label {
  font-size: 1.2rem;
  color: #6b7280;
  font-weight: 400;
}

.view-item > span {
  font-size: 1.4rem;
  color: #1f2937;
  padding: 0.75rem 1rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
}

.capacites-grid.view-mode {
  gap: 1rem;
}

/* Grille des capacités CA et RH */
.capacites-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem;
}

.capacites-grid .form-group {
  gap: 0.5rem;
}

.capacites-grid .form-group label {
  font-size: 1.2rem;
  color: #6b7280;
  font-weight: 400;
}

.capacites-grid .form-group input {
  padding: 0.75rem 1rem;
  font-size: 1.4rem;
}

/* Actions */
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}

/* Responsive */
@media screen and (max-width: 1024px) {
  .capacites-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (max-width: 768px) {
  .tab-presentation {
    padding: 1rem;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .year-row {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .year-label {
    padding-bottom: 0;
    margin-top: 0.5rem;
  }

  .capacites-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 480px) {
  .capacites-grid {
    grid-template-columns: 1fr 1fr;
  }
}

/* ================================
   Section Lots techniques
   ================================ */

/* .lots-section : plus de margin-top propre, espacement uniforme via SectionPliable. */

.section-banner-with-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #595959;
  color: #fff;
  padding: 0.75rem 1rem;
  font-weight: 600;
  font-size: 1.4rem;
  border-radius: 0.375rem 0.375rem 0 0;
}

.section-banner-with-action .section-banner {
  background: none;
  padding: 0;
  margin: 0;
  border-radius: 0;
}

.lots-view-section {
  margin-bottom: 1.5rem;
}

.lots-view-section:last-child {
  margin-bottom: 0;
}

.lots-view-section h4 {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 0.75rem 0;
}

.lots-tags,
.departements-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

/* Tags lots et départements - Style sobre gris */
.lot-tag,
.dept-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.75rem;
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #e5e7eb;
  border-radius: 0.25rem;
  font-size: 1.2rem;
  font-weight: 500;
}

/* Tag Accord-Cadre - Style avec accent orange */
.lot-tag-ac {
  background-color: #fff7ed;
  color: #c2410c;
  border-color: #fed7aa;
}

.ac-badge {
  font-size: 1rem;
  margin-left: 0.25rem;
}

.no-data {
  color: #6b7280;
  font-style: italic;
  font-size: 1.3rem;
  margin: 0;
}

.lots-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}

/* Compteur de caracteres et indication de limite */
.char-counter {
  display: block;
  text-align: right;
  font-size: 1.2rem;
  color: #6b7280;
  margin-top: 0.25rem;
}

.char-limit-hint {
  display: block;
  font-size: 1.2rem;
  color: #9ca3af;
  font-weight: 400;
  margin-top: 0.125rem;
}

.view-group {
  margin-bottom: 1.25rem;
}

.view-group:last-child {
  margin-bottom: 0;
}

.view-group label {
  display: block;
  font-size: 1.4rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.125rem;
}

/* ============================================
   FRONT-24: Section Informations légales
   ============================================ */

/* Bandeau avec action (bouton à droite) */
.section-banner-with-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #595959;
  padding: 0.5rem 1rem 0.5rem 0;
}

.section-banner-with-action .section-banner {
  padding: 0.25rem 1.25rem;
}

/* Champs en lecture seule */
.view-group.readonly label::after {
  content: " (non modifiable)";
  font-size: 0.75em;
  color: #999;
  font-style: italic;
}

.input-disabled {
  background-color: #f5f5f5 !important;
  color: #888 !important;
  cursor: not-allowed !important;
  border-color: #ddd !important;
}

/* Lignes de vue */
.view-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-bottom: 1rem;
}

.view-row.three-cols {
  grid-template-columns: repeat(3, 1fr);
}

@media screen and (max-width: 768px) {
  .view-row,
  .view-row.three-cols {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

.value-text {
  font-size: 1.4rem;
  color: #1f2937;
  margin: 0;
}

/* Affichage adresse sur plusieurs lignes */
.adresse-display {
  white-space: pre-line;
  line-height: 1.6;
}

/* Lignes de formulaire - layout générique */
.form-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.form-row.three-cols {
  grid-template-columns: repeat(3, 1fr);
}

.form-row.four-cols {
  grid-template-columns: 1fr 2fr 1fr;
}

/* Tailles de champs */
.form-group.small {
  max-width: 150px;
}

.form-group.medium {
  max-width: 250px;
}

@media screen and (max-width: 768px) {
  .form-row,
  .form-row.three-cols,
  .form-row.four-cols {
    grid-template-columns: 1fr;
  }

  .form-group.small,
  .form-group.medium {
    max-width: none;
  }
}

/* Checkbox aligné */
.form-group-checkbox {
  flex-direction: row !important;
  align-items: center;
  gap: 0.75rem !important;
}

.form-group-checkbox input[type="checkbox"] {
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
}

/* Actions du formulaire infos légales */
.infos-legales-actions {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

/* Redressement judiciaire switch (style Register.tsx) */
.redressement-section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px;
  background: #fff;
  margin-top: 1rem;
}

.redressement-label-block {
  flex: 1 1;
}

.redressement-label {
  font-weight: 500;
  margin-bottom: 8px;
  display: block;
  font-size: 1.1rem;
  color: #1f2937;
}

.redressement-description {
  color: #4a5565;
  font-size: 0.98rem;
}

.redressement-switch-control {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* Autocomplétion adresse (style Register.tsx) */
.adresse-autocomplete-container {
  position: relative;
}

.autocomplete-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  list-style-type: none;
  padding: 0;
  margin: 0;
  background: white;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 5px 5px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.autocomplete-list li {
  padding: 10px 12px;
  cursor: pointer;
  font-size: 1.3rem;
  color: #1f2937;
}

.autocomplete-list li:hover {
  background-color: #f0f0f0;
}

/* Champ en erreur */
.input-error {
  border: 2px solid #dc2626 !important;
  background-color: #fef2f2 !important;
}

.input-error:focus {
  outline-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2);
}

/* Message d'erreur sous un champ */
.field-error {
  display: block;
  color: #dc2626;
  font-size: 1.25rem;
  margin-top: 4px;
  font-weight: 500;
}

/* Message d'info sous un champ */
.field-info {
  display: block;
  color: #6b7280;
  font-size: 0.85rem;
  margin-top: 4px;
  font-style: italic;
}

/* Compteur de caractères */
.char-count {
  display: block;
  color: #9ca3af;
  font-size: 1.25rem;
  margin-top: 2px;
}

/* Astérisque obligatoire */
.required-asterisk {
  color: #dc2626;
  font-weight: bold;
  margin-left: 0.25rem;
}

/* Input avec suffixe (€, %) */
.tab-presentation .input-with-suffix {
  position: relative;
}

.tab-presentation .input-with-suffix input {
  width: 100%;
  padding-right: 2.5rem;
}

.tab-presentation .input-with-suffix .suffix {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  pointer-events: none;
  font-size: 1.3rem;
}

/* Ces regles vivaient dans Register.css et s'appliquaient ici par effet de bord du CSS global.
   L'inscription ne les utilise plus : la page profil les porte donc elle-meme, a l'identique. */
.adresse-suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 100;
  max-height: 250px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0;
}

.adresse-suggestion-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s;
  border-bottom: 1px solid #f1f5f9;
}

.adresse-suggestion-item:last-child {
  border-bottom: none;
}

.adresse-suggestion-item:hover {
  background: #f8fafc;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profil/tabs/TabPresentation.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,0FAA0F;AAC5F;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;+DAC+D;AAC/D;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;8DAC8D;;AAE9D;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;;qCAEqC;;AAErC,uFAAuF;;AAEvF;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,iDAAiD;AACjD;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,mDAAmD;AACnD;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;;iDAEiD;;AAEjD,0CAA0C;AAC1C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA,2CAA2C;AAC3C;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;gGACgG;AAChG;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,wCAAwC;EACxC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/**\n * CSS pour l'onglet Présentation\n */\n\n.tab-presentation {\n  /* Carte / fond blanc retires : les sections (SectionPliable) portent leur propre cadre. */\n}\n\n.tab-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.tab-header h2 {\n  margin: 0;\n  font-size: 2rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n/* Mode lecture */\n.presentation-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.presentation-section {\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.presentation-section:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.presentation-section h3 {\n  font-size: 1.6rem;\n  font-weight: 600;\n  color: #374151;\n  margin: 0 0 1rem 0;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.info-item label {\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.info-item span {\n  font-size: 1.4rem;\n  color: #1f2937;\n}\n\n.info-item a {\n  color: #f97316;\n  text-decoration: none;\n}\n\n.info-item a:hover {\n  text-decoration: underline;\n}\n\n.description-text {\n  font-size: 1.4rem;\n  color: #4b5563;\n  line-height: 1.6;\n  white-space: pre-line;\n}\n\n.history-table {\n  overflow-x: auto;\n}\n\n.history-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.history-table th,\n.history-table td {\n  padding: 0.75rem 1rem;\n  text-align: left;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.history-table th {\n  background: #f9fafb;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n}\n\n.history-table td {\n  font-size: 1.4rem;\n  color: #1f2937;\n}\n\n/* Mode édition */\n.presentation-form {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.form-section {\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.form-section h3 {\n  font-size: 1.6rem;\n  font-weight: 600;\n  color: #374151;\n  margin: 0 0 0.5rem 0;\n}\n\n.section-hint {\n  font-size: 1.2rem;\n  color: #6b7280;\n  margin: 0 0 1rem 0;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 1rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-group label {\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 1.2rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n  font-size: 1.6rem;\n  color: #2c3948;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n\n.form-group input::placeholder,\n.form-group textarea::placeholder {\n  color: #9ca3af;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n/* Description de l'entreprise : la hauteur suit le contenu (auto-resize JS),\n   donc pas de scroll interne ni de poignee de resize manuel. */\n.form-group textarea.auto-grow {\n  resize: none;\n  overflow: hidden;\n}\n\n/* Historique CA/RH */\n.history-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.year-row {\n  display: grid;\n  grid-template-columns: 80px 1fr 1fr;\n  gap: 1rem;\n  align-items: end;\n}\n\n.year-label {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #374151;\n  padding-bottom: 0.625rem;\n}\n\n/* Sections avec bandeau noir */\n/* .form-section-block / .section-banner : structure remplacee par SectionPliable.\n   Regles supprimees pour ne pas laisser de chrome residuel. */\n\n.section-content {\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  overflow: hidden;\n  position: relative;\n}\n\n.section-description {\n  font-size: 1.4rem;\n  color: #374151;\n  margin: 0 0 1rem 0;\n  font-weight: 500;\n}\n\n/* Mode lecture */\n.view-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.view-group label {\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.view-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.view-item label {\n  font-size: 1.2rem;\n  color: #6b7280;\n  font-weight: 400;\n}\n\n.view-item > span {\n  font-size: 1.4rem;\n  color: #1f2937;\n  padding: 0.75rem 1rem;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n}\n\n.capacites-grid.view-mode {\n  gap: 1rem;\n}\n\n/* Grille des capacités CA et RH */\n.capacites-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 1rem;\n}\n\n.capacites-grid .form-group {\n  gap: 0.5rem;\n}\n\n.capacites-grid .form-group label {\n  font-size: 1.2rem;\n  color: #6b7280;\n  font-weight: 400;\n}\n\n.capacites-grid .form-group input {\n  padding: 0.75rem 1rem;\n  font-size: 1.4rem;\n}\n\n/* Actions */\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n/* Responsive */\n@media screen and (max-width: 1024px) {\n  .capacites-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .tab-presentation {\n    padding: 1rem;\n  }\n\n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .year-row {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n\n  .year-label {\n    padding-bottom: 0;\n    margin-top: 0.5rem;\n  }\n\n  .capacites-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .capacites-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n/* ================================\n   Section Lots techniques\n   ================================ */\n\n/* .lots-section : plus de margin-top propre, espacement uniforme via SectionPliable. */\n\n.section-banner-with-action {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #595959;\n  color: #fff;\n  padding: 0.75rem 1rem;\n  font-weight: 600;\n  font-size: 1.4rem;\n  border-radius: 0.375rem 0.375rem 0 0;\n}\n\n.section-banner-with-action .section-banner {\n  background: none;\n  padding: 0;\n  margin: 0;\n  border-radius: 0;\n}\n\n.lots-view-section {\n  margin-bottom: 1.5rem;\n}\n\n.lots-view-section:last-child {\n  margin-bottom: 0;\n}\n\n.lots-view-section h4 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #374151;\n  margin: 0 0 0.75rem 0;\n}\n\n.lots-tags,\n.departements-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n/* Tags lots et départements - Style sobre gris */\n.lot-tag,\n.dept-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.25rem 0.75rem;\n  background-color: #f3f4f6;\n  color: #374151;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.25rem;\n  font-size: 1.2rem;\n  font-weight: 500;\n}\n\n/* Tag Accord-Cadre - Style avec accent orange */\n.lot-tag-ac {\n  background-color: #fff7ed;\n  color: #c2410c;\n  border-color: #fed7aa;\n}\n\n.ac-badge {\n  font-size: 1rem;\n  margin-left: 0.25rem;\n}\n\n.no-data {\n  color: #6b7280;\n  font-style: italic;\n  font-size: 1.3rem;\n  margin: 0;\n}\n\n.lots-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n/* Compteur de caracteres et indication de limite */\n.char-counter {\n  display: block;\n  text-align: right;\n  font-size: 1.2rem;\n  color: #6b7280;\n  margin-top: 0.25rem;\n}\n\n.char-limit-hint {\n  display: block;\n  font-size: 1.2rem;\n  color: #9ca3af;\n  font-weight: 400;\n  margin-top: 0.125rem;\n}\n\n.view-group {\n  margin-bottom: 1.25rem;\n}\n\n.view-group:last-child {\n  margin-bottom: 0;\n}\n\n.view-group label {\n  display: block;\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 0.125rem;\n}\n\n/* ============================================\n   FRONT-24: Section Informations légales\n   ============================================ */\n\n/* Bandeau avec action (bouton à droite) */\n.section-banner-with-action {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #595959;\n  padding: 0.5rem 1rem 0.5rem 0;\n}\n\n.section-banner-with-action .section-banner {\n  padding: 0.25rem 1.25rem;\n}\n\n/* Champs en lecture seule */\n.view-group.readonly label::after {\n  content: \" (non modifiable)\";\n  font-size: 0.75em;\n  color: #999;\n  font-style: italic;\n}\n\n.input-disabled {\n  background-color: #f5f5f5 !important;\n  color: #888 !important;\n  cursor: not-allowed !important;\n  border-color: #ddd !important;\n}\n\n/* Lignes de vue */\n.view-row {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.view-row.three-cols {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n@media screen and (max-width: 768px) {\n  .view-row,\n  .view-row.three-cols {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n}\n\n.value-text {\n  font-size: 1.4rem;\n  color: #1f2937;\n  margin: 0;\n}\n\n/* Affichage adresse sur plusieurs lignes */\n.adresse-display {\n  white-space: pre-line;\n  line-height: 1.6;\n}\n\n/* Lignes de formulaire - layout générique */\n.form-row {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n  margin-bottom: 0.75rem;\n}\n\n.form-row.three-cols {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.form-row.four-cols {\n  grid-template-columns: 1fr 2fr 1fr;\n}\n\n/* Tailles de champs */\n.form-group.small {\n  max-width: 150px;\n}\n\n.form-group.medium {\n  max-width: 250px;\n}\n\n@media screen and (max-width: 768px) {\n  .form-row,\n  .form-row.three-cols,\n  .form-row.four-cols {\n    grid-template-columns: 1fr;\n  }\n\n  .form-group.small,\n  .form-group.medium {\n    max-width: none;\n  }\n}\n\n/* Checkbox aligné */\n.form-group-checkbox {\n  flex-direction: row !important;\n  align-items: center;\n  gap: 0.75rem !important;\n}\n\n.form-group-checkbox input[type=\"checkbox\"] {\n  width: 1.5rem;\n  height: 1.5rem;\n  cursor: pointer;\n}\n\n/* Actions du formulaire infos légales */\n.infos-legales-actions {\n  margin-top: 1rem;\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n/* Redressement judiciaire switch (style Register.tsx) */\n.redressement-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: start;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 20px;\n  background: #fff;\n  margin-top: 1rem;\n}\n\n.redressement-label-block {\n  flex: 1;\n}\n\n.redressement-label {\n  font-weight: 500;\n  margin-bottom: 8px;\n  display: block;\n  font-size: 1.1rem;\n  color: #1f2937;\n}\n\n.redressement-description {\n  color: #4a5565;\n  font-size: 0.98rem;\n}\n\n.redressement-switch-control {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n/* Autocomplétion adresse (style Register.tsx) */\n.adresse-autocomplete-container {\n  position: relative;\n}\n\n.autocomplete-list {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  background: white;\n  border: 1px solid #ccc;\n  border-top: none;\n  border-radius: 0 0 5px 5px;\n  max-height: 200px;\n  overflow-y: auto;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.autocomplete-list li {\n  padding: 10px 12px;\n  cursor: pointer;\n  font-size: 1.3rem;\n  color: #1f2937;\n}\n\n.autocomplete-list li:hover {\n  background-color: #f0f0f0;\n}\n\n/* Champ en erreur */\n.input-error {\n  border: 2px solid #dc2626 !important;\n  background-color: #fef2f2 !important;\n}\n\n.input-error:focus {\n  outline-color: #dc2626;\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2);\n}\n\n/* Message d'erreur sous un champ */\n.field-error {\n  display: block;\n  color: #dc2626;\n  font-size: 1.25rem;\n  margin-top: 4px;\n  font-weight: 500;\n}\n\n/* Message d'info sous un champ */\n.field-info {\n  display: block;\n  color: #6b7280;\n  font-size: 0.85rem;\n  margin-top: 4px;\n  font-style: italic;\n}\n\n/* Compteur de caractères */\n.char-count {\n  display: block;\n  color: #9ca3af;\n  font-size: 1.25rem;\n  margin-top: 2px;\n}\n\n/* Astérisque obligatoire */\n.required-asterisk {\n  color: #dc2626;\n  font-weight: bold;\n  margin-left: 0.25rem;\n}\n\n/* Input avec suffixe (€, %) */\n.tab-presentation .input-with-suffix {\n  position: relative;\n}\n\n.tab-presentation .input-with-suffix input {\n  width: 100%;\n  padding-right: 2.5rem;\n}\n\n.tab-presentation .input-with-suffix .suffix {\n  position: absolute;\n  right: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6b7280;\n  pointer-events: none;\n  font-size: 1.3rem;\n}\n\n/* Ces regles vivaient dans Register.css et s'appliquaient ici par effet de bord du CSS global.\n   L'inscription ne les utilise plus : la page profil les porte donc elle-meme, a l'identique. */\n.adresse-suggestions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-top: none;\n  border-radius: 0 0 8px 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n  max-height: 250px;\n  overflow-y: auto;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.adresse-suggestion-item {\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: background 0.2s;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.adresse-suggestion-item:last-child {\n  border-bottom: none;\n}\n\n.adresse-suggestion-item:hover {\n  background: #f8fafc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
